(function () {

function getCurrentVariant() {
  const el = document.querySelector('variant-selects [data-selected-variant]');
  if (!el) return null;

  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

  function formatMoney(cents) {
    return "$" + (Math.round(cents) / 100).toFixed(2);
  }

  function getSoldAsSelectedValue() {
    const selected = document.querySelector('input[name="properties[Sold As]"]:checked');
    if (!selected) return "";
    return (selected.value || "").toString().trim();
  }

  function applyPricesToWrapper(wrapper, sellingCents, compareCents) {

    if (!wrapper) return;

    const saleEl = wrapper.querySelector('.price-item--sale');
    const regularEl = wrapper.querySelector('.price-item--regular');
    const compareEl = wrapper.querySelector('s.price-item--regular');

    if (saleEl) saleEl.textContent = formatMoney(sellingCents);

    if (!compareEl && regularEl) {
      regularEl.textContent = formatMoney(sellingCents);
    }

    if (compareEl && compareCents > 0) {
      compareEl.textContent = formatMoney(compareCents);
    }
  }

  function applySoldAsLabelToWrapper(wrapper) {
    if (!wrapper) return;
    const label = getSoldAsSelectedValue();
    const labelEl = wrapper.querySelector('.total-price__label');
    if (labelEl) {
      labelEl.textContent = label ? `${label}:` : '';
    }
  }

  window.updateSoldAsPrice = function () {

    /* ==========================================
       Run when mode is "both" (user picks single/pair) or "pair" (pair only, selected by default)
       ========================================== */

    const mode = (window.soldAsMode || "")
    .toString()
    .trim()
    .toLowerCase();

    if (mode !== "both" && mode !== "pair") {
      console.log("Pricing disabled. Mode:", mode);
      return;
    }

    const dropdown = document.querySelector('.sold-as-dropdown');
    if (!dropdown) return;

    const variant = getCurrentVariant();
    if (!variant) return;

    const selectedValue = getSoldAsSelectedValue();
    if (!selectedValue) return;

    const variantId = String(variant.id);

    const mainWrapper = document.querySelector('.data-price-wrapper');
    const secondaryWrapper = document.querySelector('.data-price-wrapper-secondary');

    // Read both prices from variant JSON (raw single-panel values, not DOM which Liquid may have already multiplied)
    const basePrice = parseFloat(variant.price || 0);
    const baseCompare = parseFloat(variant.compare_at_price || 0);

    let finalPrice = basePrice;
    let finalCompare = baseCompare;

    const isCurtainPairType = dropdown.dataset.isCurtainPairType === "true";
    // Curtain pair: no price doubling, no pair discount (price is already per pair)
    const effectiveDiscountPercent = isCurtainPairType ? 0 : (parseFloat(dropdown.dataset.pairDiscount || "0") || 0);

    if (selectedValue.toLowerCase().includes("pair")) {

      // For "curtain pair" type: price is already per-pair (units_per = 1), don't double it
      // For regular "sold as pair": units_per = 2, so we double the single-panel price
      if (!isCurtainPairType) {
        finalPrice = basePrice * 2;
        finalCompare = basePrice * 2;
      }

      if (effectiveDiscountPercent > 0) {
        finalPrice -= finalPrice * effectiveDiscountPercent / 100;
      }

    } else {
      finalPrice = basePrice;
      finalCompare = baseCompare;
    }

    if (mode === 'both') {
      // "Both" mode: Liquid renders both_single + both_pair prices statically.
      // They NEVER change. Only the secondary wrapper updates based on selection.

    } else {
      // "pair" mode (single option only): update the full main wrapper
      applyPricesToWrapper(mainWrapper, finalPrice, finalCompare);

      // Update the sale-percentage badge in the PRIMARY wrapper
      if (mainWrapper) {
        const saleBadge = mainWrapper.querySelector('.sale-percentage');
        if (saleBadge) {
          if (finalCompare > 0 && finalCompare > finalPrice) {
            const discountPct = Math.round(((finalCompare - finalPrice) / finalCompare) * 100);
            saleBadge.textContent = discountPct + '% OFF';
            saleBadge.style.display = '';
          } else {
            saleBadge.textContent = '';
            saleBadge.style.display = 'none';
          }
        }
      }
    }

    // Always update secondary wrapper (mobile price bar etc.) unless layering upsell owns it
    if (!window.layeringUpsellActive) {
      applyPricesToWrapper(secondaryWrapper, finalPrice, finalCompare);
      applySoldAsLabelToWrapper(secondaryWrapper);
    }

    // Also update configurator total price label (used by sticky add-to-cart clone)
    applySoldAsLabelToWrapper(document.querySelector('.product-form__total-price'));

    // Re-sync secondary so sale-percentage (X% OFF) is recalculated from updated primary
    if (!window.layeringUpsellActive && typeof window.syncSecondaryPrice === 'function') {
      setTimeout(window.syncSecondaryPrice, 0);
    }
    if (window.layeringUpsellActive && typeof window.updateLayeringBundlePrice === 'function') {
      setTimeout(window.updateLayeringBundlePrice, 0);
    }
  };

  // Sold As change
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === "properties[Sold As]") {
      setTimeout(window.updateSoldAsPrice, 50);
    }
  });

  // Variant change
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === "id" || e.target.closest('[name="id"]'))) {
      setTimeout(window.updateSoldAsPrice, 200);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(window.updateSoldAsPrice, 300);
  });

})();